var moduleMap = {
	"./Navigation": () => {
		return Promise.all([__webpack_require__.e(4490), __webpack_require__.e(6612)]).then(() => (() => ((__webpack_require__(16612)))));
	},
	"./AuthenticatedPage": () => {
		return Promise.all([__webpack_require__.e(8775), __webpack_require__.e(9891), __webpack_require__.e(6634), __webpack_require__.e(6673), __webpack_require__.e(6677), __webpack_require__.e(4144), __webpack_require__.e(1527), __webpack_require__.e(9579), __webpack_require__.e(7220), __webpack_require__.e(8663), __webpack_require__.e(5929), __webpack_require__.e(1461), __webpack_require__.e(4490), __webpack_require__.e(6681), __webpack_require__.e(4691), __webpack_require__.e(3288), __webpack_require__.e(4018)]).then(() => (() => ((__webpack_require__(53138)))));
	},
	"./ModalNotification": () => {
		return Promise.all([__webpack_require__.e(8775), __webpack_require__.e(6673), __webpack_require__.e(1603), __webpack_require__.e(1527), __webpack_require__.e(9579), __webpack_require__.e(8663), __webpack_require__.e(5929), __webpack_require__.e(9059)]).then(() => (() => ((__webpack_require__(89059)))));
	},
	"./NotificationBox": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(9579), __webpack_require__.e(6681), __webpack_require__.e(5186)]).then(() => (() => ((__webpack_require__(85186)))));
	},
	"./ModalNotificationContext": () => {
		return Promise.all([__webpack_require__.e(9579), __webpack_require__.e(2508)]).then(() => (() => ((__webpack_require__(82508)))));
	},
	"./LoadingSpinner": () => {
		return Promise.all([__webpack_require__.e(9891), __webpack_require__.e(8051), __webpack_require__.e(1527), __webpack_require__.e(1461), __webpack_require__.e(2899)]).then(() => (() => ((__webpack_require__(32899)))));
	},
	"./usePermissions": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(9579), __webpack_require__.e(7220), __webpack_require__.e(1461), __webpack_require__.e(5643)]).then(() => (() => ((__webpack_require__(35643)))));
	},
	"./PrivateRoute": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(9579), __webpack_require__.e(7220), __webpack_require__.e(8663), __webpack_require__.e(1461), __webpack_require__.e(4490), __webpack_require__.e(7624)]).then(() => (() => ((__webpack_require__(37624)))));
	},
	"./Permissions": () => {
		return __webpack_require__.e(6072).then(() => (() => ((__webpack_require__(86072)))));
	},
	"./RootState": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(1252), __webpack_require__.e(1393)]).then(() => (() => ((__webpack_require__(1252)))));
	},
	"./LocaleModule": () => {
		return Promise.all([__webpack_require__.e(8663), __webpack_require__.e(5662)]).then(() => (() => ((__webpack_require__(35662)))));
	},
	"./KeyboardNavigation": () => {
		return __webpack_require__.e(5225).then(() => (() => ((__webpack_require__(25225)))));
	},
	"./workflowKeys": () => {
		return __webpack_require__.e(5131).then(() => (() => ((__webpack_require__(55131)))));
	},
	"./convertToProperCase": () => {
		return __webpack_require__.e(2022).then(() => (() => ((__webpack_require__(32022)))));
	},
	"./numberFormatter": () => {
		return __webpack_require__.e(7543).then(() => (() => ((__webpack_require__(97543)))));
	},
	"./updateLanguage": () => {
		return Promise.all([__webpack_require__.e(8663), __webpack_require__.e(1805), __webpack_require__.e(951)]).then(() => (() => ((__webpack_require__(40951)))));
	},
	"./useRefreshProfile": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(1230)]).then(() => (() => ((__webpack_require__(89881)))));
	},
	"./UI": () => {
		return __webpack_require__.e(9579).then(() => (() => ((__webpack_require__(89579)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});